<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import Labels from 'shared/components/kp-label/Labels.svelte';
    import {getLocalization, getSanitize} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import InfoBanner from 'shared/ui-widgets/banner/InfoBanner.svelte';

    const localize = getLocalization();
    const sanitizeHtml = getSanitize();
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    const model = pageContext.staticData.model;
</script>

<div class="record-heading-container">
    <!-- Title -->
    <KpHeading type="h1" id="detail-main-name">{model.record.name}</KpHeading>

    {#if model.record.deleted}
        <InfoBanner bannerType="error">
            <svelte:fragment slot="text">
                {localize(/* @kp-localization record.DeletedRecordBannerMessage */ 'record.DeletedRecordBannerMessage')}
            </svelte:fragment>
        </InfoBanner>
    {/if}

    {#if model.record.forbidden}
        <InfoBanner bannerType="error">
            <svelte:fragment slot="text">
                {localize(/* @kp-localization record.ForbiddenRecordBannerMessage */ 'record.ForbiddenRecordBannerMessage')}
            </svelte:fragment>
        </InfoBanner>
    {/if}

    <!-- Subtitle -->
    {#if model.record.subtitle && model.record.subtitle.length > 0}
        <span id="detail-main-subtitle" class="subtitle">
            <Labels labeleds={model.record.subtitle} linkifyUrls={true}/>
        </span>
    {/if}

    <!-- Related records -->
    {#each model.relatedRecordItems as relatedRecordItem}
        <div class="related-record">
            <span>{@html sanitizeHtml(relatedRecordItem.field787Value)}</span>

            {#if relatedRecordItem.partValue}
                <span>, {localize(/* @kp-localization commons.part */ 'commons.part')} {@html sanitizeHtml(relatedRecordItem.partValue)}</span>
            {/if}
        </div>
    {/each}

    <!-- Responsibility statement -->
    {#if model.record.responsibilityStatement}
        <div id="detail-main-responsibility" class="responsibility">
            <Labels labeleds={[model.record.responsibilityStatement]} linkifyUrls={true}/>
        </div>
    {/if}

    <!-- Value of subfield 100 abc -->
    {#if model.sf100abcFieldValue}
        <div id="detail-main-100abc">{@html sanitizeHtml(model.sf100abcFieldValue)}</div>
    {/if}

    <!-- Primary authors -->
    {#if model.record.primaryAuthors && model.record.primaryAuthors.length > 0}
        <div id="detail-main-author" class="main-author">
            <Labels labeleds={model.record.primaryAuthors}/>
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .subtitle {
        margin: 0;
    }

    .subtitle {
        color: gray;
        font-size: @font-size-h3;
    }

    .main-author {
        color: blue;
    }

    .main-author,
    .related-record,
    .responsibility {
        font-size: 1.1em;
        margin-bottom: 10px;
    }

    .main-author {
        margin-bottom: 0;
    }
</style>